/**
 * @generated SignedSource<<cf626f75f1e9ae179789a238010aaf58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleAdminItemWeekdayIndicator_RoutineScheduleDaily$data = {
  readonly weekdays: ReadonlyArray<{
    readonly weekday: number;
  }>;
  readonly " $fragmentType": "TeamScheduleAdminItemWeekdayIndicator_RoutineScheduleDaily";
};
export type TeamScheduleAdminItemWeekdayIndicator_RoutineScheduleDaily$key = {
  readonly " $data"?: TeamScheduleAdminItemWeekdayIndicator_RoutineScheduleDaily$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleAdminItemWeekdayIndicator_RoutineScheduleDaily">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleAdminItemWeekdayIndicator_RoutineScheduleDaily",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineScheduleDailyWeekday",
      "kind": "LinkedField",
      "name": "weekdays",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weekday",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineScheduleDaily",
  "abstractKey": null
};

(node as any).hash = "5de25376621dad985eeab932f980222e";

export default node;
